import React, { useState, useEffect } from "react"
import BackLogo from '../../../../images/rewampimages/Chevron.png'
import SettingsIcon from '@mui/icons-material/Settings';
import SchemaIcon from '@mui/icons-material/Schema';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TuneIcon from '@mui/icons-material/Tune';
import ConfigureTemplate from './TemplatesConfiguration/Main'
import CommDashboardMain from './CommDashboard/Main'
import NotificationsIcon from '@mui/icons-material/Notifications';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Mappings from './Mappings/Main'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import Logs from './Logs'
import CallIcon from '@mui/icons-material/Call';
export default function Main({ admin, pageViewHandler }) {

    const [viewState, setViewState] = useState('flow');
    const [configState, setconfigState] = useState('mail')

    const handeNavbarState = (e, type) => {
        setViewState(type)
        setconfigState("mail")
    }

    const handleconfigState = (e, type) => {
        setconfigState(type)
    }

    const handleBackBtn = (e) => {
        if (viewState === 'config') {
            setViewState('flow')
        }else{
            pageViewHandler(e, 'landingPage')
        }
    }
    return (
        <>
            <div className="container-fluid details-new fixed-top"  >
                <div className="row details-new-tab-div" style={{ display: 'flex', justifyContent: 'end' }}>
                    <div className="col-sm-6 col-xs-12 " style={{ marginTop: '15px', marginBottom: viewState === 'config' ? "15px" : "0px" }}>
                        <img onClick={(e) => handleBackBtn(e)} style={{ cursor: 'pointer' }} src={BackLogo} width={'30px'} /> <button style={{ color: '#1D3557', fontWeight: '700' }} onClick={(e) => handleBackBtn(e)} >Back</button>
                    </div>

                    <div className=" col-lg-6 col-xs-12" style={{ fontSize: '10px', display: 'flex', justifyContent: 'end' }}>
                        <div className="btn-group-new" style={{ display: viewState === 'config' ? 'flex' : "", alignItems: 'center' }}>
                            {
                                viewState !== 'config' ?
                                    <>
                                        <button className={(viewState === 'flow') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'flow')}><DashboardIcon style={{ fontSize: '27px' }} /><br />Dashboard</button>
                                        <button className={(viewState === 'mapping') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'mapping')}><FormatListBulletedIcon style={{ fontSize: '27px' }} /><br />Mappings</button>
                                        <button className={(viewState === 'config') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'config')}><SettingsIcon style={{ fontSize: '27px' }} /><br />Configure Templates</button>
                                        <button className={(viewState === 'logs') ? "active" : ""} onClick={(e) => handeNavbarState(e, 'logs')}><FormatListNumberedIcon style={{ fontSize: '27px' }} /><br />Logs</button>
                                    </>
                                    : ''}
                            {/* {
                                viewState === 'config' ?
                                    <>
                                        <button className={(configState === 'mail') ? "active" : ""} style={{ fontSize: '16px', background: configState === "mail" ? "#337ab7" : "", color: configState === "mail" ? "#fff" : "#000", borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'mail')}>
                                            E-Mail
                                        </button>
                                        <button className={(configState === 'sms') ? "active" : ""} style={{ fontSize: '16px', background: configState === "sms" ? "#337ab7" : "", color: configState === "sms" ? "#fff" : "#000", borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'sms')}>
                                            SMS
                                        </button>
                                        <button className={(configState === 'whatsapp') ? "active" : ""} style={{ fontSize: '16px', background: configState === "whatsapp" ? "#337ab7" : "", color: configState === "whatsapp" ? "#fff" : "#000", borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'whatsapp')}>
                                            Whatsapp
                                        </button>
                                        <button className={(configState === 'notification') ? "active" : ""} style={{ fontSize: '16px', background: configState === "notification" ? "#337ab7" : "", color: configState === "notification" ? "#fff" : "#000", borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'notification')}>
                                           <NotificationsIcon style={{fontSize:'20px'}}/> <br/> Notification
                                        </button>
                                        <button className={(configState === 'call') ? "active" : ""} style={{ fontSize: '16px', background: configState === "call" ? "#337ab7" : "", color: configState === "call" ? "#fff" : "#000", borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'call')}>
                                            Call
                                        </button>
                                    </>
                                    : ''} */}
                            {
                                viewState === 'config' ?
                                    <>
                                        <button className={(configState === 'mail') ? "active" : ""} style={{ fontSize: '14px', color: configState === "mail" ? "#337ab7" : "#aaa",  borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'mail')}>
                                          <EmailIcon style={{fontSize:'20px'}}/> <br/>  E-Mail
                                        </button>
                                        <button className={(configState === 'sms') ? "active" : ""} style={{ fontSize: '14px', color: configState === "sms" ? "#337ab7" : "#aaa",  borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'sms')}>
                                            <SmsIcon style={{fontSize:'20px'}}/> <br/>SMS
                                        </button>
                                        <button className={(configState === 'whatsapp') ? "active" : ""} style={{ fontSize: '14px', color: configState === "whatsapp" ? "#337ab7" : "#aaa",  borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'whatsapp')}>
                                          <WhatsAppIcon style={{fontSize:'20px'}}/> <br/>  Whatsapp
                                        </button>
                                        <button className={(configState === 'notification') ? "active" : ""} style={{ fontSize: '14px', color: configState === "notification" ? "#337ab7" : "#aaa",  borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'notification')}>
                                           <NotificationsIcon style={{fontSize:'20px'}}/> <br/> Notification
                                        </button>
                                        <button className={(configState === 'call') ? "active" : ""} style={{ fontSize: '16px', color: configState === "call" ? "#337ab7" : "#aaa", borderRadius: '6px' }} onClick={(e) => handleconfigState(e, 'call')}>
                                            <CallIcon tyle={{fontSize:'20px'}}/> <br/> Call
                                        </button>
                                    </>
                                    : ''}
                        </div>
                    </div>
                </div>
            </div>
                {
                    viewState === "config" ?
                        <ConfigureTemplate admin={admin} configState={configState}/>
                        : ""
                }
                {
                    viewState === "flow" ?
                        <CommDashboardMain admin={admin} />
                        : ""
                }
                {
                    viewState === "mapping" ?
                        <Mappings admin={admin} />
                        : ""
                }
                {
                    viewState === "logs" ?
                        <Logs admin={admin} />
                        : ""
                }
               
        </>
    )
}